import React, {useState} from 'react'
import tick from '../../assets/png/Group 70.png'

export default function Check({checked, text, disabled, name, handleChange}) {
    const [check, setCheck] = useState(checked)
    const toggleCheck = () => {
       if (handleChange) handleChange({[name]: !check})
        setCheck(!check)
    }
    return (

                <div className="check">
                    <div className={"box " + (disabled? "disabled": '')} onClick={toggleCheck}>
                    {check?  <img src={tick} alt=""/>:""}
                        </div> 
                    <p className="checkTitle">{text}</p>
                </div>


    )
}
